import { useContext } from 'react'
import { SearchFiltersContext } from './SearchFiltersContext'

export function useSearchFilters() {
  const context = useContext(SearchFiltersContext)
  if (!context) {
    throw new Error('useSearchFilters must be used within a SearchFiltersProvider')
  }
  return context
}
